<div class="justup-dialog">
  <vl-dialog-header-export
    [exporting]="exporting()"
    (close)="dialogRef.close()"
    (export)="exportExcel()">
    Lots par état — Détail
  </vl-dialog-header-export>

  <div class="justup-dialog-content flex-col gap-16">
    <!-- ═══ Toggles : type lot + pivot groupBy ═══ -->
    <div class="flex-row justify-center align-center gap-16 wrap">
      <vl-chips-toggle
        [elements]="lotTypeOptions"
        [value]="lotType()"
        (valueChange)="lotType.set($any($event))"
        size="small"/>
      <vl-chips-toggle
        [elements]="groupByOptions"
        [value]="groupBy()"
        (valueChange)="groupBy.set($any($event))"
        size="small"/>
    </div>

    <!-- ═══ Stats cards (4) ═══ -->
    <div class="flex-row gap-8 wrap">
      <vl-radio-card mode="display" color="warn" icon="schedule"
                     title="Lots impactés"
                     style="flex: 1; min-width: 140px">
        <span content class="headline">{{ stats().nbLots }}</span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="error" icon="euro"
                     title="Valeur immobilisée"
                     style="flex: 1; min-width: 140px">
        <span content class="headline">{{ stats().coutTotal | numberSig }} €</span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="basic" icon="inventory_2"
                     title="Quantité totale"
                     style="flex: 1; min-width: 140px">
        <span content class="headline">{{ stats().qtyTotale | numberSig }}</span>
      </vl-radio-card>

      <vl-radio-card mode="display" color="secondary" icon="leaderboard"
                     [title]="topCardTitle()"
                     style="flex: 1; min-width: 140px">
        <div content class="flex-col gap-2">
          <span class="body-2" style="font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
                [title]="stats().topLabel">
            {{ stats().topLabel }}
          </span>
          <span class="tiny" style="opacity: 0.7">
            {{ stats().topShare | number:'1.1-1':'fr-FR' }} % de la valeur
          </span>
        </div>
      </vl-radio-card>
    </div>

    <!-- ═══ Actions de pliage + entête colonnes ═══ -->
    <div class="flex-row gap-8 align-center wrap">
      <vl-chips size="small" state="enabled" iconLeft="unfold_more"
                (action)="expandAll()"
                matTooltip="Déplier tous les groupes">
        Tout déplier
      </vl-chips>
      <vl-chips size="small" state="enabled" iconLeft="unfold_less"
                (action)="collapseAll()"
                matTooltip="Réduire tous les groupes">
        Tout replier
      </vl-chips>
      <div class="grow"></div>
      <span class="tiny on-background-alt">
        {{ groups().length }} groupe{{ groups().length > 1 ? 's' : '' }}
      </span>
    </div>

    <!-- ═══ Header colonnes ═══ -->
    <div class="flex-row gap-8 p-8 align-center"
         style="padding-right: 12px; border-bottom: 1px solid var(--color-on-disabled)">
      <span class="shrink-0" style="width: 16px"></span>
      <span class="shrink-0" style="width: 10px"></span>
      <span class="grow tiny on-background-alt"
            style="font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
        {{ groupColumnLabel() }}
      </span>
      <span class="tiny on-background-alt shrink-0"
            matTooltip="Nombre de lots distincts dans ce groupe"
            style="min-width: 60px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
        Lots
      </span>
      <span class="tiny on-background-alt shrink-0"
            matTooltip="Quantité totale en stock (toutes unités confondues)"
            style="min-width: 70px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
        Quantité
      </span>
      <span class="tiny on-background-alt shrink-0"
            matTooltip="Valeur stock cumulée immobilisée pour ce groupe"
            style="min-width: 90px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
        Valeur
      </span>
      <span class="tiny on-background-alt shrink-0"
            matTooltip="Part du groupe dans la valeur totale immobilisée"
            style="min-width: 50px; text-align: right; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em">
        Part
      </span>
    </div>

    <!-- ═══ Arbre expandable groupé — 3 niveaux Group → Article → Lot ═══ -->
    @if (groups().length === 0) {
      <div class="empty-state flex-col align-center justify-center gap-8 p-32">
        <mat-icon class="on-disabled" style="font-size: 48px; width: 48px; height: 48px">inventory_2</mat-icon>
        <span class="caption on-background-alt" style="font-style: italic">
          Aucun lot dans ce périmètre.
        </span>
      </div>
    } @else {
      @for (g of groups(); track g.groupKey) {
        <!-- LEVEL 0 : groupe (famille / article / emplacement) -->
        <div>
          <div class="flex-row gap-8 p-8 align-center border-box border-8 cursor-pointer"
               [style.border-left]="'3px solid ' + getColor(g.groupKey)"
               style="border: 1px solid var(--color-outline)"
               (click)="toggleGroup(g.groupKey)">
            <mat-icon class="on-disabled shrink-0" style="font-size: 16px; width: 16px; height: 16px">
              {{ isExpanded(g.groupKey) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
            <span class="shrink-0 border-full" [style.background-color]="getColor(g.groupKey)"
                  style="width: 10px; height: 10px"></span>
            <div class="grow flex-col" style="min-width: 0">
              <span class="caption on-background-alt"
                    style="font-weight: 600; overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                {{ g.label }}
              </span>
              @if (g.meta) {
                <span class="tiny on-disabled" style="font-style: italic">{{ g.meta }}</span>
              }
            </div>
            <span class="tiny on-disabled shrink-0" style="min-width: 60px; text-align: right">
              {{ g.nbLots }}
            </span>
            <span class="tiny on-disabled shrink-0" style="min-width: 70px; text-align: right">
              {{ g.qtyTotale | numberSig }}
            </span>
            <span class="tiny on-background-alt shrink-0" style="min-width: 90px; text-align: right; font-weight: 600">
              {{ g.coutTotal | numberSig }} €
            </span>
            <span class="tiny on-accent shrink-0" style="min-width: 50px; text-align: right">
              {{ partPct(g.coutTotal) | number:'1.1-1':'fr-FR' }} %
            </span>
          </div>

          <!-- LEVEL 1 : articles (sous le groupe) -->
          @if (isExpanded(g.groupKey)) {
            <div class="flex-col gap-1 mt-2 mb-2" style="margin-left: 24px">
              @for (a of g.articles; track a.articleId) {
                @let artKey = g.groupKey + '::' + a.articleId;
                <div>
                  <div class="flex-row gap-8 p-4 align-center cursor-pointer"
                       (click)="toggleGroup(artKey); $event.stopPropagation()">
                    <mat-icon class="on-disabled shrink-0" style="font-size: 14px; width: 14px; height: 14px">
                      {{ isExpanded(artKey) ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                    <!-- Affichage compact texte (pattern valeur-stock) :
                         nom de l'article + référence en sous-titre. Pas de
                         card/image pour rester dense et lisible sur 1-2 lignes. -->
                    <div class="grow flex-col" style="min-width: 0; gap: 2px">
                      <span class="caption" style="font-weight: 600; color: var(--color-on-background); overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
                        {{ a.label }}
                      </span>
                      @if (a.code) {
                        <span class="tiny on-disabled" style="font-variant-numeric: tabular-nums">
                          {{ a.code }}
                        </span>
                      }
                    </div>
                    <span class="tiny on-disabled shrink-0" style="min-width: 60px; text-align: right">
                      {{ a.nbLots }}
                    </span>
                    <span class="tiny on-disabled shrink-0" style="min-width: 70px; text-align: right">
                      {{ a.qtyTotale | numberSig }}
                    </span>
                    <span class="tiny on-background-alt shrink-0" style="min-width: 90px; text-align: right; font-weight: 600">
                      {{ a.coutTotal | numberSig }} €
                    </span>
                    <span class="tiny on-accent shrink-0" style="min-width: 50px; text-align: right">
                      {{ partPct(a.coutTotal) | number:'1.1-1':'fr-FR' }} %
                    </span>
                  </div>

                  <!-- LEVEL 2 : lots (sous l'article) — cards minimalistes,
                       numéro cliquable via vl-lot-card mode="text" pour
                       naviguer vers /lots/infos. -->
                  @if (isExpanded(artKey) && a.lots.length) {
                    <div class="flex-col gap-2 mt-1 mb-2" style="margin-left: 22px">
                      @for (l of a.lots; track l.lotId + '|' + l.emplacement) {
                        <div class="flex-row gap-12 p-8 border-on-disabled border-box border-8 align-center">
                          <div class="flex-col gap-2 grow" style="min-width: 0">
                            <div class="flex-row gap-8 align-baseline flex-wrap">
                              <vl-lot-card [lotId]="l.lotId" mode="text"/>
                              <span class="tiny on-background-alt">{{ l.emplacement }}</span>
                              @if (lotType() !== 'nc' && l.dluo) {
                                <vl-date-limite-display
                                  [dluo]="l.dluo"
                                  [typeDateLimite]="l.typeDateLimite ?? 'DDM'"
                                  [format]="l.dluoFormat ?? 'dd/MM/yyyy'"
                                  size="compact"/>
                              }
                            </div>
                            <div class="flex-row gap-4 align-baseline">
                              <span class="tiny on-disabled" style="min-width: 60px">Stock</span>
                              <span class="tiny on-background-alt">{{ l.quantite | numberSig }} u</span>
                              <span class="tiny on-disabled">×</span>
                              <span class="tiny on-background-alt">{{ l.coutUnitaire | numberSig }} €/u</span>
                              <span class="tiny on-disabled">=</span>
                              <span class="tiny on-background-alt" style="font-weight: 600">{{ l.coutTotal | numberSig }} €</span>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    }
  </div>
</div>
